// extracted by mini-css-extract-plugin
export default {"FsnModal":"Modal_FsnModal__G4uPh","content":"Modal_content__6Pnqb","title":"Modal_title__p-V3F","text":"Modal_text__5m6WA","closeBtn":"Modal_closeBtn__UVUsp"};